<template>
    <el-dialog v-model="dialogVisible" :close-on-click-modal="false" width="40%" :show-close="false">
        <template #title>
            <div style="display: flex; justify-content: space-between; align-items: center;">
                <span>{{ props.row ? 'Edit Customer' : 'Add Customer' }}</span>
                <div style="display: flex; align-items: center; gap: 6px;">
                    <el-button size="small" type="warning" @click="handleReset">Reset</el-button>
                </div>
            </div>
        </template>

        <el-form :model="form" ref="formRef" :rules="rules" label-width="150px" size="small">
            <el-form-item label="Username: " prop="username">
                <el-input v-model="form.username" style="width: 250px" />
            </el-form-item>
            <el-form-item label="Name: " prop="name">
                <el-input v-model="form.name" style="width: 250px" />
            </el-form-item>
            <el-form-item label="Phone: " prop="phone">
                <el-input v-model="form.phone" style="width: 250px" />
            </el-form-item>
            <el-form-item label="Email: " prop="email">
                <el-input v-model="form.email" style="width: 250px" />
            </el-form-item>
            <el-form-item label="Address: " prop="address">
                <el-input v-model="form.address" style="width: 250px" />
            </el-form-item>
            <el-form-item label="Remark: " prop="remark">
                <el-input v-model="form.remark" type="textarea" :rows="5" style="width: 250px" />
            </el-form-item>
            <el-form-item label="Status: " prop="status">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">Active</el-radio>
                    <el-radio :label="0">Disabled</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>

        <template #footer>
            <el-button @click="dialogVisible = false" size="small">Cancel</el-button>
            <el-button type="primary" @click="handleSubmit" size="small">Confirm</el-button>
        </template>
    </el-dialog>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import { registerCustomer, updateCustomer } from '@/api/customer'
import { useMutation } from '@/composables/useMutation'
import { defaultCustomer } from '../../defaults'

const props = defineProps({
    visible: { type: Boolean, default: false },
    row: { type: Object, default: null }
})
const emit = defineEmits(['update:visible', 'saved'])

const dialogVisible = computed({
    get: () => props.visible,
    set: (val) => emit('update:visible', val)
})

const formRef = ref(null)
const form = ref({ ...defaultCustomer })

const rules = {
    username: [{ required: true, message: 'This field is required', trigger: 'blur' }],
    name: [{ required: true, message: 'This field is required', trigger: 'blur' }],
    phone: [{ required: true, message: 'This field is required', trigger: 'blur' }],
}

watch(() => props.visible, (val) => {
    if (val) {
        form.value = props.row ? { ...props.row } : { ...defaultCustomer }
    } else {
        formRef.value?.resetFields()
    }
})

const { mutate } = useMutation({ useOverlay: true })

function handleReset() {
    formRef.value?.resetFields()
}

async function handleSubmit() {
    const valid = await formRef.value?.validate().catch(() => false)
    if (!valid) return

    ElMessageBox.confirm('Are you sure to submit this form?', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
    }).then(() => {
        mutate(
            () => props.row ? updateCustomer(form.value.id, form.value) : registerCustomer(form.value),
            {
                success: props.row ? 'Successfully updated!' : 'Successfully added!',
                onSuccess: () => {
                    dialogVisible.value = false
                    emit('saved')
                }
            }
        )
    }).catch(() => { })
}
</script>
